export default __webpack_public_path__ + "static/media/rafael-sanchez.1c501c8d.png";